import handleResponseNotifications from './handleResponseNotifications';

const getResponseJson = async (response, { nextCallback, notification = true } = {}) => {
    let responseJson = null;
    try {
        responseJson = await response.json();
    } catch (error) {
        console.error('JSON parsing failed:', error);
    }
    if (response.ok) {
        if (typeof nextCallback === 'function') {
            nextCallback();
        } else {
            const { redirect_url: redirectUrl } = responseJson || {};
            if (redirectUrl) {
                setTimeout(() => { // setTimeout is used to ensure the response is processed before the redirect (eg. in case of unsaved changes)
                    window.location.href = redirectUrl;
                }, 0);
            }
        }
    }
    if (notification) {
        handleResponseNotifications({ response, responseJson });
    }
    return responseJson;
};

export default getResponseJson;
